import React from "react";

export function OccupancyTypeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.25 53.67"
      width="30"
      height="30"
      fill="white"
      {...props}
    >
      <path
        className="cls-1"
        d="m47.98,53.67h-12.78v-5.42c0-2.66.01-4.13-.95-5.84-1.98-3.51-3.81-3.65-5.59-3.78-1.12-.08-2.28-.17-3.38-1.07-2.59-2.11-4.27-5.24-4.27-7.96,0-3.52,2.52-6.39,5.62-6.39s5.62,2.87,5.62,6.39c0,1.58-.51,3.09-1.44,4.27l-.84,1.1-.8-.61.84-1.11c.79-1,1.23-2.3,1.23-3.66,0-2.97-2.07-5.39-4.62-5.39s-4.62,2.42-4.62,5.39c0,2.44,1.53,5.26,3.9,7.19.85.69,1.76.76,2.82.84,1.94.15,4.14.32,6.38,4.29,1.09,1.94,1.09,3.59,1.08,6.33v4.42s10.78,0,10.78,0v-22.43l4.83-4.83L26.23,1.38,1.42,24.97l4.68,4.88v21.44c0,.76.62,1.39,1.39,1.39h9.2v-3.71c0-.72-.03-1.36-.05-1.94-.08-1.75-.14-3.02.68-4.55.69-1.3,1.47-1.9,2.29-2.53.79-.61,1.68-1.3,2.73-2.79l.82.58c-1.14,1.61-2.09,2.35-2.93,3-.8.62-1.43,1.1-2.02,2.21-.69,1.29-.64,2.38-.57,4.03.03.59.06,1.24.06,1.98v4.71H7.48c-1.32,0-2.39-1.07-2.39-2.39v-21.04L0,24.93,26.23,0l27.03,25.38-5.27,5.27v23.02Z"
      />
    </svg>
  );
}
